module.exports = __webpack_public_path__ + "static/media/2.2.2215603a.png";